import comp from "./CardCommentsV2";
export default comp;
